import { render, staticRenderFns } from "./AvaliationList.vue?vue&type=template&id=5c1f17f8"
import script from "./AvaliationList.vue?vue&type=script&lang=js"
export * from "./AvaliationList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports